export const setTemplates = (state, templates) => {
  state.templates = templates
}

export const addTemplate = (state, template) => {
  state.templates.unshift(template)
}

export const updateTemplate = (state, data) => {
  let template = _.find(state.templates, { id: data.id })
  template.body = data.body
  template.category = data.category
  template.sex = data.sex
}

export const removeTemplate = (state, template) => {
  state.templates = state.templates.filter(t => t.id !== template.id)
}
